module.exports = __webpack_public_path__ + "img/Fabrique_en_France.735d9749.png";